/**
 * 交易相关API接口
 */
import request from '@/utils/request'
import { GLOBAL_URL } from '@/enums'
import * as type from './types'

/**
 * 获取充值记录（基于时间范围）
 * @param params 时间范围参数
 * @param loading 是否显示loading状态
 */
export function getDepositRecordsByTimeRange(
    params: type.TimeRangeParams,
    loading = true,
    options?: object
): Promise<type.TransactionDepositRecordsResponse> {
    return request({
        ...options,
        url: GLOBAL_URL.PayOrders, // 复用现有的PayOrders接口
        method: 'post',
        data: params, // 参数为 { start, end } 而不是 { from, size }
        loading,
    })
}

/**
 * 获取提现记录（基于时间范围）
 * @param params 时间范围参数
 * @param loading 是否显示loading状态
 */
export function getWithdrawRecordsByTimeRange(
    params: type.TimeRangeParams,
    loading = true,
    options?: object
): Promise<type.TransactionWithdrawRecordsResponse> {
    return request({
        ...options,
        url: GLOBAL_URL.PayoutOrders, // 使用提现记录接口
        method: 'post',
        data: params,
        loading,
    })
}

/**
 * 充值订单加速
 * @param params 加速参数 { orderid: string }
 * @param loading 是否显示loading状态
 */
export function speedUpDeposit(params: type.SpeedUpDepositParams, loading = true): Promise<type.SpeedUpDepositResponse> {
    return request({
        url: GLOBAL_URL.PayinSpeedup,
        method: 'post',
        data: params,
        loading,
    })
}

/**
 * 订单查询
 * @param params 查询参数 { type: string, orderid: string }
 * @param loading 是否显示loading状态
 */
export function queryOrder(params: type.QueryOrderParams, loading = true): Promise<type.QueryOrderResponse> {
    return request({
        url: GLOBAL_URL.QueryOrder,
        method: 'post',
        data: params,
        loading,
    })
}

/**
 * 交易消息删除
 * @param params 删除参数 { channle: string, id: string }
 * @param loading 是否显示loading状态
 */
export function deleteTransactionMessage(
    params: type.DeleteTransactionMessageParams,
    loading = true
): Promise<type.DeleteTransactionMessageResponse> {
    return request({
        url: GLOBAL_URL.DeleteMessage,
        method: 'post',
        data: params,
        loading,
    })
}
